export default {
  active: {
    id: 'policy_state_tag_active',
    defaultMessage: 'Active',
  },
  awaitingActivation: {
    id: 'policy_state_tag_awaiting_activation',
    defaultMessage: 'Awaiting activation',
  },
  expired: {
    id: 'policy_state_tag_expired',
    defaultMessage: 'Expired',
  },
  cancelled: {
    id: 'policy_state_tag_cancelled',
    defaultMessage: 'Canceled',
  },
  onHold: {
    id: 'policy_state_tag_on_hold',
    defaultMessage: 'On hold',
  },
}
